<div class="modal-overlay" (click)="onCancel()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <div class="header-content">
                <div class="modal-icon">
                    <mat-icon aria-hidden="true">{{ data.id ? 'edit_note' : 'add_circle_outline' }}</mat-icon>
                </div>
                <h2 class="modal-title">{{ data.id ? 'Modifier le rôle' : 'Nouveau rôle' }}</h2>
            </div>
            <button class="close-btn" (click)="onCancel()">×</button>
        </div>

        <form [formGroup]="roleForm" (ngSubmit)="onSave()" class="modal-body">
            @if (errorMessage) {
            <div class="alert alert-error mb-4">
                {{ errorMessage }}
            </div>
            }
            <div class="form-group">
                <label for="name">NOM DU RÔLE</label>
                <input id="name" type="text" formControlName="name" placeholder="Ex: ADMIN, USER, MANAGER..."
                    class="form-control">
                @if (roleForm.get('name')?.invalid && roleForm.get('name')?.touched) {
                <span class="error-text">Le nom est requis</span>
                }
            </div>

            <div class="modal-footer">
                @if (data.id) {
                <button type="button" class="btn btn-danger-outline" (click)="onRequestDelete()">
                    Supprimer
                </button>
                }
                <button type="button" class="btn btn-outline" (click)="onCancel()">Annuler</button>
                <button type="submit" class="btn btn-primary" [disabled]="roleForm.invalid">
                    {{ data.id ? 'Enregistrer les modifications' : 'Créer le rôle' }}
                </button>
            </div>
        </form>
    </div>
</div>

@if (isDeleteConfirmOpen) {
<app-confirmation-dialog [dialogTitle]="canDeleteRole ? 'Supprimer le rôle' : 'Suppression impossible'"
    [message]="getDeleteDialogMessage()" [confirmLabel]="canDeleteRole ? 'Supprimer' : 'OK'" [isDanger]="canDeleteRole"
    (confirm)="canDeleteRole ? confirmDelete() : cancelDelete()" (cancel)="cancelDelete()">
</app-confirmation-dialog>
}